import { forwardRef } from "react";

const Switch = forwardRef<
  HTMLInputElement,
  Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "className">
>((props, ref) => {
  return (
    <label className="flex items-center cursor-pointer select-none text-dark dark:text-white">
      <div className="relative">
        <input type="checkbox" ref={ref} className="peer sr-only" {...props} />
        <div className="block h-6 rounded-full box bg-gray-300 w-10 peer-checked:bg-primary"></div>
        <div className="absolute flex items-center justify-center w-4 h-4 transition bg-white rounded-full dot left-1 top-1 dark:bg-dark-5 peer-checked:translate-x-full peer-checked:dark:bg-white"></div>
      </div>
    </label>
  );
});

export default Switch;
